import { useGetRequiredRule } from '@/hooks';
import { PickingFormFields } from '@/modules/Regions/helpers/types';
import { useTranslation } from 'react-i18next';

export const usePickupFormValidation = () => {
  const { t } = useTranslation(['validations']);
  const requiredRule = useGetRequiredRule({ t });
  return {
    [PickingFormFields.SETTLEMENT]: [requiredRule],
    [PickingFormFields.ADDRESS]: [requiredRule],
    [PickingFormFields.PHONE]: [requiredRule],
    [PickingFormFields.IS_ACTIVE]: [requiredRule],
    [PickingFormFields.IS_DEFAULT]: [requiredRule],
    [PickingFormFields.WORKING_HOURS]: [requiredRule],
    [PickingFormFields.REGION]: [requiredRule],
  };
};
